// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__24tCj","colCheckbox":"styles_colCheckbox__xPjxy"};